import { JSONValue } from '@/utils/types';

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';

export const FEATURE_FLAGS = {
	GDPR_OPT_OUT_BY_DEFAULT_FLAG: 'gdpr-opt-out-by-default',
	ZOOM_APP: 'zoom-app',
};

export type FeatureFlags = Record<string, JSONValue>;

interface SetFeatureFlagsAction {
	type: typeof SET_FEATURE_FLAGS;
	payload: FeatureFlags;
}

export type FeatureFlagsActionType = SetFeatureFlagsAction;
